import { render, staticRenderFns } from "./nameService.vue?vue&type=template&id=71f7ee0d&scoped=true&"
import script from "./nameService.vue?vue&type=script&lang=js&"
export * from "./nameService.vue?vue&type=script&lang=js&"
import style0 from "./nameService.vue?vue&type=style&index=0&id=71f7ee0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f7ee0d",
  null
  
)

export default component.exports